import { makeClient } from '@updater/ui-utilities';

import { guestAuthLink } from './guest-auth-link';

export type GuestApolloClient = ReturnType<typeof makeClient>;

export interface MakeGuestApolloClientOptions {
  apiBaseUrl?: string;
  version?: string;
}

/**
 * The Apollo client used on guest routes. Independent of the signed-in client:
 *
 * - Its only session is the anonymous `createPublicSession` token, applied by
 *   `guestAuthLink`, so the signed-in session can never be forwarded from a
 *   guest route.
 * - It has no `logoutLink`. A 401 on a guest request must not call `signOut()`,
 *   which would DELETE the session server side and clear the shared
 *   `.updater.com` cookies.
 * - It has its own `InMemoryCache`, so guest responses can't be read back by
 *   the signed-in client.
 *
 * `requestHeaders` stays session-free on purpose — see `guestAuthLink` for why
 * the session headers have to be applied in the link instead.
 */
export function makeGuestApolloClient({
  apiBaseUrl,
  version,
}: MakeGuestApolloClientOptions): GuestApolloClient {
  return makeClient({
    requestHeaders: () => ({
      name: 'consumer-app',
      version: '0.1',
      app: 'mover',
    }),
    url: `${apiBaseUrl}/graphql`,
    // fetchGQL appends /graphql itself, so the mint takes the base url.
    links: [guestAuthLink(apiBaseUrl ?? '')],
    name: 'consumer-app',
    version,
  });
}
